// ToolFormatter for Platinum CLI (`pt`) commands.
// When the agent runs a Bash tool call whose command starts with `pt `,
// we display it as "Platinum CLI" with the actual command as the summary.
// The parsePtCommand helper from frontend/src/agent handles env-var stripping
// and sub-command matching.

import type { ToolFormatter } from '../agent'
import { parsePtCommand } from '../agent'

export const ptToolFormatter: ToolFormatter = {
  displayName(toolName: string, input: unknown): string | undefined {
    const match = parsePtCommand(toolName, input as Record<string, unknown>)
    if (!match) return undefined
    return match.def.displayName
  },

  summary(toolName: string, input: unknown): string | undefined {
    const match = parsePtCommand(toolName, input as Record<string, unknown>)
    if (!match) return undefined
    return match.fullCommand
  },
}
